import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { mustBeArray } from "../../../utils/lib";
import Select from "react-select";

/**
 * @typedef {Object} Region
 * @property {number} id
 * @property {string} name
 */

/**
 * @typedef {Object} Option
 * @property {number} value
 * @property {string} label
 */

/**
 * @param {{
 *  value: Option[],
 *  onChange: (values: Option[]) => void
 * }} props
 * @returns
 */
function RegionSelect({ value, onChange }) {
  /**
   * @type {[Option[], React.Dispatch<Option[]>]} state
   */
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  async function getRegionOptions() {
    setLoading(true);
    try {
      /**
       * @type {import("axios").AxiosResponse<Region[]>}
       */
      const response = await request.get("/api/regions/lookup");
      const mappedOptions = mustBeArray(response.data).map((x) => ({
        value: x.id,
        label: x.name,
      }));
      setOptions(mappedOptions);
      onChange(mappedOptions);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      getRegionOptions();
    });

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="form-group row">
      <label className="col-md-2 form-control-label" htmlFor="mode">
        Region
      </label>
      <div className="col-md-6">
        {loading ? (
          <div className="row justify-content-center">
            <div className="col-auto">
              Loading... <i className="fa fa-cog fa-spin" />
            </div>
          </div>
        ) : (
          <Select
            multi
            simpleValue={false}
            options={options}
            value={value}
            onChange={onChange}
          />
        )}
      </div>
    </div>
  );
}

export default RegionSelect;
